import { render, staticRenderFns } from "./Prerequisites.vue?vue&type=template&id=e82d0b80"
import script from "./Prerequisites.vue?vue&type=script&lang=js"
export * from "./Prerequisites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports